"use strict";

var _interopRequireWildcard = require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.regexp.replace");
require("core-js/modules/es6.regexp.split");
var _defineProperty2 = _interopRequireDefault(require("/data/www/prod-cn-snote-cms/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
var Quill = _interopRequireWildcard(require("quill"));
require("quill/dist/quill.core.css");
require("quill/dist/quill.snow.css");
require("quill/dist/quill.bubble.css");
var _blog = require("../../api/blog.js");
var _upload = require("../../api/upload.js");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// 标题
var titleConfig = [{
  Choice: ".ql-bold",
  title: "加粗"
}, {
  Choice: ".ql-italic",
  title: "斜体"
}, {
  Choice: ".ql-underline",
  title: "下划线"
}, {
  Choice: ".ql-header",
  title: "段落格式"
}, {
  Choice: ".ql-strike",
  title: "删除线"
}, {
  Choice: ".ql-blockquote",
  title: "块引用"
}, {
  Choice: ".ql-code",
  title: "插入代码"
}, {
  Choice: ".ql-code-block",
  title: "插入代码段"
}, {
  Choice: ".ql-font",
  title: "字体"
}, {
  Choice: ".ql-size",
  title: "字体大小"
}, {
  Choice: '.ql-list[value="ordered"]',
  title: "编号列表"
}, {
  Choice: '.ql-list[value="bullet"]',
  title: "项目列表"
}, {
  Choice: ".ql-direction",
  title: "文本方向"
}, {
  Choice: '.ql-header[value="1"]',
  title: "h1"
}, {
  Choice: '.ql-header[value="2"]',
  title: "h2"
}, {
  Choice: ".ql-align",
  title: "对齐方式"
}, {
  Choice: ".ql-color",
  title: "字体颜色"
}, {
  Choice: ".ql-background",
  title: "背景颜色"
}, {
  Choice: ".ql-image",
  title: "图像"
}, {
  Choice: ".ql-video",
  title: "视频"
}, {
  Choice: ".ql-link",
  title: "添加链接"
}, {
  Choice: ".ql-formula",
  title: "插入公式"
}, {
  Choice: ".ql-clean",
  title: "清除字体格式"
}, {
  Choice: '.ql-script[value="sub"]',
  title: "下标"
}, {
  Choice: '.ql-script[value="super"]',
  title: "上标"
}, {
  Choice: '.ql-indent[value="-1"]',
  title: "向左缩进"
}, {
  Choice: '.ql-indent[value="+1"]',
  title: "向右缩进"
}, {
  Choice: ".ql-header .ql-picker-label",
  title: "标题大小"
}, {
  Choice: '.ql-header .ql-picker-item[data-value="1"]',
  title: "标题一"
}, {
  Choice: '.ql-header .ql-picker-item[data-value="2"]',
  title: "标题二"
}, {
  Choice: '.ql-header .ql-picker-item[data-value="3"]',
  title: "标题三"
}, {
  Choice: '.ql-header .ql-picker-item[data-value="4"]',
  title: "标题四"
}, {
  Choice: '.ql-header .ql-picker-item[data-value="5"]',
  title: "标题五"
}, {
  Choice: '.ql-header .ql-picker-item[data-value="6"]',
  title: "标题六"
}, {
  Choice: ".ql-header .ql-picker-item:last-child",
  title: "标准"
}, {
  Choice: '.ql-size .ql-picker-item[data-value="small"]',
  title: "小号"
}, {
  Choice: '.ql-size .ql-picker-item[data-value="large"]',
  title: "大号"
}, {
  Choice: '.ql-size .ql-picker-item[data-value="huge"]',
  title: "超大号"
}, {
  Choice: ".ql-size .ql-picker-item:nth-child(2)",
  title: "标准"
}, {
  Choice: ".ql-align .ql-picker-item:first-child",
  title: "居左对齐"
}, {
  Choice: '.ql-align .ql-picker-item[data-value="center"]',
  title: "居中对齐"
}, {
  Choice: '.ql-align .ql-picker-item[data-value="right"]',
  title: "居右对齐"
}, {
  Choice: '.ql-align .ql-picker-item[data-value="justify"]',
  title: "两端对齐"
}];
var _default = exports.default = {
  data: function data() {
    return (0, _defineProperty2.default)((0, _defineProperty2.default)({
      rules: {
        seq: [{
          required: true,
          message: "序号不能为空",
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: "标题不能为空",
          trigger: "blur"
        }],
        author: [{
          required: true,
          message: "作者不能为空",
          trigger: "blur"
        }]
      },
      imageUrl2: "",
      imageUrl1: "",
      addRange: [],
      addRange1: [],
      Rangeflag: false,
      Rangeflag1: false,
      formLabelWidth: "200px",
      editorOption: {
        placeholder: "请输入文本信息..."
      },
      editorOption1: {
        placeholder: "请输入文本信息..."
      },
      addblog: {
        id: "",
        seq: "",
        language: "",
        author: "",
        title: "",
        content: "",
        urlPc: "",
        urlMobile: "",
        seoTitle: '',
        seoKeyword: "",
        seoDescription: "",
        line: "",
        viewCount: "",
        commentsCount: "",
        thumbsCount: "",
        viewCountReal: "",
        commentsCountReal: "",
        thumbsCountReal: "",
        recommendFlag: "",
        awsContent: ''
      },
      value: ""
    }, "formLabelWidth", "200px"), "editorOption", {});
  },
  created: function created() {
    this.getParams();
  },
  methods: {
    onEditorBlur: function onEditorBlur(v) {},
    onEditorFocus: function onEditorFocus(v) {},
    onEditorChange: function onEditorChange(v) {},
    onEditorBlur1: function onEditorBlur1(v) {},
    onEditorFocus1: function onEditorFocus1(v) {},
    onEditorChange1: function onEditorChange1(v) {},
    getParams: function getParams() {
      var _this = this;
      // 将数据放在当前组件的数据内
      this.addblog.id = this.$route.query.id;
      (0, _blog.getBlogById)(this.addblog.id).then(function (res) {
        _this.addblog.title = res.title;
        _this.addblog.recommendFlag = res.recommendFlag;
        _this.addblog.author = res.author;
        _this.imageUrl1 = res.urlPc.split('===')[0];
        _this.imageUrl2 = res.urlMobile.split('===')[0];
        _this.addblog.urlPc = res.urlPc;
        _this.addblog.urlMobile = res.urlMobile;
        _this.addblog.seoTitle = res.seoTitle;
        _this.addblog.seoKeyword = res.seoKeyword;
        _this.addblog.seoDescription = res.seoDescription;
        _this.addblog.viewCount = res.viewCount;
        _this.addblog.line = res.line;
        _this.addblog.language = res.language;
        _this.addblog.commentsCount = res.commentsCount;
        _this.addblog.thumbsCount = res.thumbsCount;
        _this.addblog.viewCountReal = res.viewCountReal;
        _this.addblog.commentsCountReal = res.commentsCountReal;
        _this.addblog.thumbsCountReal = res.thumbsCountReal;
        _this.addblog.content = res.content;
        _this.addblog.awsContent = res.awsContent;
      });
    },
    // 点击图片ICON触发事件
    imgHandler: function imgHandler(state) {
      this.addRange = this.$refs.myQuillEditor.quill.getSelection();
      if (this.addRange != "" && this.addRange != null) {
        this.Rangeflag = true;
      }
      this.addRange1 = this.$refs.myQuillEditor1.quill.getSelection();
      if (this.addRange1 != "" && this.addRange1 != null) {
        this.Rangeflag1 = true;
      }
      if (state) {
        var fileInput = document.getElementById("imgInput");
        fileInput.click(); // 加一个触发事件
      }
    },
    to_upload_img: function to_upload_img(formdata) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var fd = new FormData();
        fd.append("file", formdata.file);
        if (_this2.Rangeflag) {
          (0, _upload.uploads)(fd).then(function (res) {
            _this2.addRange = _this2.$refs.myQuillEditor.quill.getSelection();
            _this2.$refs.myQuillEditor.quill.insertEmbed(_this2.addRange !== null ? _this2.addRange.index : 0, "image", res.voT.downloadUrl, Quill.sources.USER); // 调用编辑器的 insertEmbed 方法，插入URL
            _this2.Rangeflag = false;
          });
        }
        if (_this2.Rangeflag1) {
          (0, _upload.awsupload)(fd).then(function (res) {
            _this2.addRange1 = _this2.$refs.myQuillEditor1.quill.getSelection();
            _this2.$refs.myQuillEditor1.quill.insertEmbed(_this2.addRange1 !== null ? _this2.addRange1.index : 0, "image", res.voT.downloadUrl, Quill.sources.USER); // 调用编辑器的 insertEmbed 方法，插入URL
            _this2.Rangeflag1 = false;
          });
        }
      });
    },
    // 上传文件之前的钩子
    beforeUploadPicture2: function beforeUploadPicture2(file) {
      var _this3 = this;
      if (!(file.type === "image/png" || file.type === "image/gif" || file.type === "image/jpg" || file.type === "image/jpeg")) {
        this.msgTip("warning", "请上传格式为png, gif, jpg, jpeg的图片");
        return;
      }
      var fd = new FormData();
      fd.append("file", file); //传文件
      (0, _upload.upload)(fd).then(function (res) {
        _this3.imageUrl2 = res.voT.downloadUrl.split('===')[0];
        _this3.addblog.urlMobile = res.voT.downloadUrl;
      });
      return false; //屏蔽了action的默认上传
    },
    // 上传文件之前的钩子
    beforeUploadPicture1: function beforeUploadPicture1(file) {
      var _this4 = this;
      if (!(file.type === "image/png" || file.type === "image/gif" || file.type === "image/jpg" || file.type === "image/jpeg")) {
        this.msgTip("warning", "请上传格式为png, gif, jpg, jpeg的图片");
        return;
      }
      var fd = new FormData();
      fd.append("file", file); //传文件
      (0, _upload.upload)(fd).then(function (res) {
        _this4.imageUrl1 = res.voT.downloadUrl.split('===')[0];
        _this4.addblog.urlPc = res.voT.downloadUrl;
      });
      return false; //屏蔽了action的默认上传
    },
    back: function back(formName) {
      var _this5 = this;
      this.$refs[formName].resetFields();
      this.$store.dispatch("tagsView/delView", this.$route).then(function () {
        _this5.$nextTick(function () {
          _this5.$router.replace({
            path: "/blog/blogList",
            query: {
              line: _this5.$route.query.line,
              titleId: _this5.$route.query.titleId,
              recommendFlag: _this5.$route.query.recommendFlag,
              pageNo: _this5.$route.query.pageNo
            }
          });
        });
      });
    },
    msgTip: function msgTip(msgType, msgInfo) {
      this.$message({
        type: msgType,
        message: msgInfo,
        center: true
      });
    },
    save: function save(formName) {
      var _this6 = this;
      // this.addblog.urlPc = this.imageUrl1;
      // this.addblog.urlMobile = this.imageUrl2;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          if (_this6.addblog.viewCount != "") {
            if (!/^[0-9]{1,}[\d]*$/.test(_this6.addblog.viewCount)) {
              _this6.msgTip("warning", "浏览数只能为正整数");
              return;
            }
          }
          if (_this6.addblog.commentsCount != "") {
            if (!/^[0-9]{1,}[\d]*$/.test(_this6.addblog.commentsCount)) {
              _this6.msgTip("warning", "评论数只能为正整数");
              return;
            }
          }
          if (_this6.addblog.thumbsCount != "") {
            if (!/^[0-9]{1,}[\d]*$/.test(_this6.addblog.thumbsCount)) {
              _this6.msgTip("warning", "点赞数只能为正整数");
              return;
            }
          }
          if (_this6.imageUrl1 == "") {
            _this6.msgTip("warning", "必须上传PC端图片");
            return;
          }
          if (_this6.imageUrl2 == "") {
            _this6.msgTip("warning", "必须上传手机端图片");
            return;
          }
          (0, _blog.updateBlog)(_this6.addblog).then(function (res) {
            if (res.success) {
              _this6.msgTip("success", "操作成功");
              _this6.$refs[formName].resetFields();
              _this6.$store.dispatch("tagsView/delView", _this6.$route).then(function () {
                _this6.$nextTick(function () {
                  _this6.$router.replace({
                    path: "/blog/blogList",
                    query: {
                      line: _this6.$route.query.line,
                      titleId: _this6.$route.query.titleId,
                      recommendFlag: _this6.$route.query.recommendFlag,
                      pageNo: _this6.$route.query.pageNo
                    }
                  });
                });
              });
            } else {
              _this6.$message({
                type: "warning",
                message: res.errorMsg,
                center: true
              });
            }
          });
        }
      });
    }
  },
  mounted: function mounted() {
    // 为图片ICON绑定事件  getModule 为编辑器的内部属性
    this.$refs.myQuillEditor.quill.getModule("toolbar").addHandler("image", this.imgHandler);
    this.$refs.myQuillEditor1.quill.getModule("toolbar").addHandler("image", this.imgHandler);
    autotip: {
      document.getElementsByClassName("ql-editor")[0].dataset.placeholder = "";
      for (var _i = 0, _titleConfig = titleConfig; _i < _titleConfig.length; _i++) {
        var item = _titleConfig[_i];
        var tip = document.querySelector(".quill-editor " + item.Choice);
        if (!tip) continue;
        tip.setAttribute("title", item.title);
      }
    }
  },
  watch: {
    // 监测路由变化,只要变化了就调用获取路由参数方法将数据存储本组件即可
    $route: "getParams"
  }
};